exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-store {\n  margin-right: 12px;\n}\n.error-store .ivu-badge-dot {\n  top: 20px;\n}\n.error-store .ivu-btn.ivu-btn-text {\n  padding: 5px 1px 6px;\n}\n", ""]);

// exports
